import _ from 'lodash';
import { CONSTANT_DATA_FIELD } from '../../../../utils/constants';

export const DOWNLOAD_TYPE_STEP = [
    {
        titleCode: 'MIGRATION_REPORTS',
        title: 'Migration Report',
        index: 1,
        isActive: true
    }
];

export const MIGRATION_REPORT = [
    {
        formData: [
            {
                titleCode: 'REPORT_TYPE',
                title: 'Report Type',
                field: 'reportName',
                type: CONSTANT_DATA_FIELD.SELECT_FIELD,
                isRequired: true,
                class: 'col-6 me-3'
            },
            {
                titleCode: 'ESTATE',
                title: 'Estate',
                field: 'estate',
                type: CONSTANT_DATA_FIELD.SELECT_FIELD,
                renderCondition: (values: any) => _.get(values, `reportName`)?.code == 1
            },
            {
                titleCode: 'PAYMENT_TYPE',
                title: 'Payment Type',
                field: 'paymentTypes',
                type: CONSTANT_DATA_FIELD.SELECT_FIELD,
                renderCondition: (values: any) => _.get(values, `reportName`)?.code == 1
            },
            {
                titleCode: 'ADVERTISMENT_NO',
                title: 'Advertisment Nos.',
                field: 'advertismentNo',
                type: CONSTANT_DATA_FIELD.TEXT_FIELD,
                isRequired: true,
                renderCondition: (values: any) => _.get(values, `reportName`)?.code == 3 || _.get(values, `reportName`)?.code == 4
            },
            {
                titleCode: 'PAYMENT_RECEIPT_REQUIRED',
                title: 'Is payment receipt required?',
                field: 'isPaymentReceiptRequired',
                options: [
                    { value: true, title: 'Yes' },
                    { value: false, title: 'No' }
                ],
                type: CONSTANT_DATA_FIELD.RADIO_FIELD,
                renderCondition: (values: any) => _.get(values, `reportName`)?.code == 3 || _.get(values, `reportName`)?.code == 4
            }
        ]
    }
];

export const DROPDOWN_DATA = {
    reportName: [
        { code: '1', name: 'Migration Data Payable Amount Report', active: true },
        { code: '2', name: 'Migration Data Entry Report', active: true },
        { code: '3', name: 'Paid Applications Not Submitted – Plot Allotment via Advertisement', active: true },
        { code: '4', name: 'Disqualified Applications – Plot Allotment via Advertisement', active: true }
    ],
    paymentTypes: [
        { code: 'LAND_PREMIUM', name: 'Land Premium' },
        { code: 'LEASE_RENT', name: 'Lease Rent' },
        { code: 'HOUSE_TAX', name: 'House Tax' },
        { code: 'WATER_CHARGES', name: 'Water Charges' },
        { code: 'SUBLEASE_FEE', name: 'Sub-Lease Fee' }
    ]
};
